import * as React from 'react';
import { Breadcrumb, Divider } from 'antd';

const { Item } = Breadcrumb;

export default () => (

  <React.Fragment>

    <Breadcrumb separator="»">

      <Item>
        Home
      </Item>

      <Item>
        Settings
      </Item>

      <Item>
        Item Descriptions
      </Item>

    </Breadcrumb>
      
    <Divider />

  </React.Fragment>

)